import { AfterViewInit, Component, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { withLatestFrom } from "rxjs/operators";
import { ReportExportService } from "../../api/services";
import { ParamFilter, PowerbiReportEmbedComponent } from "../../elements/powerbi-report-embed/powerbi-report-embed.component";
import { GuidService } from "../../services/guid-service";
import { GlobalApp } from "../../tools/global";

@Component({
  selector: "embed-report-public-component",
  templateUrl: "./embed-report-public.component.html"
})
export class EmbedReportPublicComponent implements AfterViewInit {

  @ViewChild(PowerbiReportEmbedComponent) powerBi: PowerbiReportEmbedComponent;
  public showReport: boolean = false;
  public isInvalid: boolean = false;
  public isExpired: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private app: GlobalApp,
    private reportExportService: ReportExportService
  ) {
    app.setFullScreenMode();
  }

  ngAfterViewInit() {
    this.route.url.pipe(
      withLatestFrom(this.route.paramMap, this.route.queryParamMap)
    ).subscribe(([url, param, query]) => {
      var inputEmbedToken: string = param.get('embedToken');
      var embedToken: string = GuidService.ShiftGuid(inputEmbedToken);
      this.app.getAuthorizationStatus().subscribe((authStatus) => {
        console.log(authStatus);
        if (authStatus.isValid) {
          this.reportExportService.reportExportGetEmbedReportDetails(embedToken).subscribe((result) => {

            let paramFilter: ParamFilter | undefined;

            if (
              query.get('zipCode') ||
              query.get('cbsaCode') ||
              query.get('onetCode') ||
              query.get('jobTitle') ||
              query.get('indeedCompany') ||
              query.get('companyKey') ||
              query.get('organizationId') ||
              query.get('naicsCode') ||
              query.get('dateRangeStart') ||
              query.get('dateRangeEnd')
            ) {
              paramFilter = {
                zipCode: query.get('zipCode'),
                cbsaCode: query.get('cbsaCode'),
                onetCode: query.get('onetCode'),
                jobTitle: query.get('jobTitle'),
                indeedCompany: query.get('indeedCompany'),
                companyKey: query.get('companyKey'),
                orgId: query.get('organizationId'),
                naicsCode: query.get('naicsCode'),
                dateRangeStart: query.get('dateRangeStart'),
                dateRangeEnd: query.get('dateRangeEnd')
              };
            }

            if (!result.valid) {
              this.isInvalid = true;
            } else if (!result.subscriptionValid) {
              this.isExpired = true;
            } else {
              this.reportExportService.reportExportLogGatedWidgetUsage({
                embedId: embedToken,
                queryParameters: JSON.stringify(paramFilter)
              }).subscribe((_) => {
                this.powerBi.loadEmbeddedState(false, result, result.reportEmbeddedExport, [], result.reportSource, result.reportEmbeddedType, false, false, null, paramFilter);
                this.showReport = true;
              });
            }
          });
        } else {
          this.app.returnUrl = '/report-embed-public/' + inputEmbedToken;
          this.app.logOut();
          this.router.navigate(["login"]);
        }
      });
    });
  }
}
